"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _lodash = require("lodash");

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.list-sync"));

var _knotchincWebReactComponents2 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.box"));

var _knotchincWebReactComponents3 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.input"));

var _knotchincWebReactComponents4 = _interopRequireDefault(require("@bit/knotchinc.web-react-components.filter-container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ListFilter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListFilter, _React$Component);

  function ListFilter(props) {
    var _this;

    _classCallCheck(this, ListFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListFilter).call(this, props));
    _this.debouncedSearch = (0, _lodash.debounce)(function (val) {
      return _this.props.search(val);
    }, 200);
    return _this;
  }

  _createClass(ListFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          _fetch = _this$props.fetch,
          listStore = _this$props.listStore,
          filterAction = _this$props.filterAction,
          filterCondition = _this$props.filterCondition,
          children = _this$props.children,
          showSearch = _this$props.showSearch;
      var container = null;

      if (this._scrollContainerRef) {
        container = this._scrollContainerRef._container;
      }

      return _react["default"].createElement(_knotchincWebReactComponents4["default"], {
        title: title
      }, showSearch && _react["default"].createElement(_knotchincWebReactComponents2["default"], {
        pt: "12px"
      }, _react["default"].createElement(_knotchincWebReactComponents3["default"], {
        hideErrorText: true,
        placeholder: "Search ".concat(title),
        callback: function callback(value) {
          return _this2.debouncedSearch(value);
        }
      })), _react["default"].createElement(_knotchincWebReactComponents2["default"], {
        pt: "12px",
        height: "250px"
      }, _react["default"].createElement(_reactPerfectScrollbar["default"], {
        ref: function ref(_ref) {
          _this2._scrollContainerRef = _ref;
        }
      }, _react["default"].createElement(_knotchincWebReactComponents["default"], {
        fetch: function fetch(clear) {
          return _fetch(clear);
        },
        listStore: listStore,
        container: container,
        loadOnScroll: true,
        actionType: filterAction,
        filterCondition: filterCondition
      }, children))));
    }
  }]);

  return ListFilter;
}(_react["default"].Component);

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var filterAction = _ref2.filterAction,
      searchBy = _ref2.searchBy;
  return {
    search: function search(value) {
      var filters = {
        searchQuery: value,
        searchBy: value ? searchBy : '',
        pageNum: 1
      };
      dispatch({
        type: filterAction,
        filters: filters
      });
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ListFilter);

exports["default"] = _default;

//# sourceMappingURL=ListFilter.js.map